import React, { useEffect } from 'react';
import './newjobmodal.css';
import NewJob from './newjob';

const NewJobModal = ({ showModal, toggleModal, onJobCreated, initialData }) => {
  // Add/remove class to App when modal opens/closes
  useEffect(() => {
    const appElement = document.querySelector('.App');
    if (showModal) {
      appElement?.classList.add('newjob-open');
    } else {
      appElement?.classList.remove('newjob-open');
    }
    
    // Cleanup on unmount
    return () => {
      appElement?.classList.remove('newjob-open');
    };
  }, [showModal]);

  if (!showModal) {
    return null;
  }

  return (
    <div className="newjobmodal-overlay">
      <div className="newjobmodal-content">
        <NewJob
          onJobCreated={onJobCreated}
          onClose={toggleModal}
          initialData={initialData}
        />
      </div>
    </div>
  );
};

export default NewJobModal;